import React, { useState, useEffect } from 'react';
import {FormComponent} from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';
import Editor from "@monaco-editor/react";
import { changedDocumentService } from '../services';

const ReMonacoTestComponent = ({
  document,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {

  const [value, setValue] = useState();
  
  function onChange(value) {
    setValue(value);

    changedDocumentService.valueChanged({
      document,
      fieldName,
      fieldValue,
      formParameters,
      template,
      componentDefinition,
      key
    }, value);
  };
  
  useEffect(() => {
    if (fieldValue) {
      setValue(fieldValue);
    } else if (componentDefinition.defaultValue) {
      setValue(componentDefinition.defaultValue);
    }
  }, []);

  return (
    <Editor
    defaultLanguage="javascript"
    defaultValue={fieldValue}
    onChange={onChange}
    height="90vh"
  />
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('re-monaco-test', ReMonacoTestComponent);

// register an alternative name for display in AngularJS 1 because the AngularJS directive name can't have the same name as the
// custom element
// convertToCustomElement('re-monaco-test-ng1', ReMonacoTestComponent);

export default ReMonacoTestComponent;
